module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAxUlEQVR4AcWXuQ2EQBAEx8YnCIIlHAKBBDYC3HOHr+9/V3VStzQmUwXsG1sys1trWGteq6zVr9XEn7L1Us+yMcTqbuGnfM64Vsvh2arXXcTsQjbvMhEJwad8nyH0SZJL1MGVOfRfkkvUwZUSGhxZJ8HhSq8RmmOdBIeL2dw/CCRoD9CAw5EEh3MJDocSHM4lOJxLcDiX4HAuweEGAf8v8A9C/zT0L0T+pdi/GVm3Y+uBxH4k8x9K/cdy/8XEfjXzXk7d1/MFMRzgZE0Nt7oAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = 251
// module chunks = 0